import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Form, Input } from 'antd'

const Item = Form.Item

export default class ConsultingEdit extends Component {

    // 基礎通用參數 //////////////////////////////////////////////    

    static propTypes = {
        modalform: PropTypes.func.isRequired,
        item: PropTypes.object.isRequired
    }

    fm = React.createRef();
    UNSAFE_componentWillMount() {
        // 將form對象透過modalform()傳遞給父組件
        this.props.modalform(this.fm)
    }




    render() {
        const { gid, serviceTitle, serviceDescription, serviceDepartment, serviceStaffName, serviceTelephone, locationAddress, handlingTime, applicableObjects } = this.props.item
        const formItemLayout = {
            labelCol: {
                xs: {
                    span: 24,
                },
                sm: {
                    span: 4,
                },
            },
            wrapperCol: {
                xs: {
                    span: 24,
                },
                sm: {
                    span: 16,
                },
            },
        };
        return (
            <div>
                <Form
                    ref={this.fm}
                    {...formItemLayout}
                >
                    <Item label="gid"
                        name="gid"
                        hidden={true}
                        initialValue={gid}
                    >
                        <Input placeholder=''  />
                    </Item>
                    <Item
                        label="諮詢項目"
                        name="serviceTitle"
                        initialValue={serviceTitle}
                        rules={[
                            { required: true, message: '' },
                        ]}
                    >
                        <Input placeholder='' />
                    </Item>
                    <Item
                        label="項目說明"
                        name="serviceDescription"
                        initialValue={serviceDescription}
                        rules={[
                            { required: true, message: '' },
                        ]}
                    >
                        <Input.TextArea />
                    </Item>
                    <Item
                        label="服務單位"
                        name="serviceDepartment"
                        initialValue={serviceDepartment}
                        rules={[
                            { required: true, message: '' },
                        ]}
                    >
                        <Input placeholder='' />
                    </Item>
                    <Item
                        label="承辦人"
                        name="serviceStaffName"
                        initialValue={serviceStaffName}
                        rules={[
                            { required: true, message: '' },
                        ]}
                    >
                        <Input placeholder='' />
                    </Item>
                    <Item
                        label="連絡電話"
                        name="serviceTelephone"
                        initialValue={serviceTelephone}
                        rules={[
                            { required: true, message: '' },
                        ]}
                    >
                        <Input placeholder='' />
                    </Item>
                    <Item
                        label="服務地點"
                        name="locationAddress"
                        initialValue={locationAddress}
                        rules={[
                            { required: true, message: '' },
                        ]}
                    >
                        <Input placeholder='' />
                    </Item>
                    <Item
                        label="處理時間"
                        name="handlingTime"
                        initialValue={handlingTime}
                        rules={[
                            { required: true, message: '' },
                        ]}
                    >
                        <Input placeholder='' />
                    </Item>
                    <Item
                        label="服務對象"
                        name="applicableObjects"
                        initialValue={applicableObjects}
                        rules={[
                            { required: true, message: '' },
                        ]}
                    >
                        <Input placeholder='' />
                    </Item>
                </Form>
            </div>
        )
    }
}